'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * SimpleErrorObject
 */
var SimpleErrorObject = function () {
  /**
   *
   * @param errors
   */
  function SimpleErrorObject(errors) {
    _classCallCheck(this, SimpleErrorObject);

    try {
      if (errors) this.valid(errors);
      this.errors = errors ? errors : {};
    } catch (e) {
      console.error(e);
      this.errors = {};
    }
  }

  /**
   * check error object
   * error object style must be following style.
   * {
   *  // error properties must be an array
   *  error1: [],
   *  error2: []
   * }
   * @param errors
   * @throws
   */


  _createClass(SimpleErrorObject, [{
    key: 'valid',
    value: function valid(errors) {
      if ((typeof errors === 'undefined' ? 'undefined' : _typeof(errors)) !== 'object') throw 'Given variable is not Object.';
      if (errors.length !== undefined) throw 'Given variable is not Object.';
      // is object
      for (var key in errors) {
        if (_typeof(errors[key]) != 'object' || _typeof(errors[key]) == 'object' && errors[key].length === undefined) {
          throw "Given Object [" + key + "] value is not an Array.\nValues must be an Array object.";
        }
      }
    }

    /**
     * add error
     * @param id
     * @param description
     * @returns {*}
     */

  }, {
    key: 'add',
    value: function add(id, description) {
      try {
        if (!id) throw 'id is not given';
        if (this.has(id)) {
          this.errors[id].push(description);
        } else {
          this.errors[id] = [description];
        }
      } catch (e) {
        debugger;
        throw e;
      }
    }

    /**
     * check id error is exist.
     * check having errors when param id not given.
     * @param id
     * @returns {boolean}
     */

  }, {
    key: 'has',
    value: function has(id) {
      if (id) {
        return this.errors[id] === undefined ? false : true;
      } else {
        var had = false;
        for (var key in this.errors) {
          if (key) had = true;
        }
        return had;
      }
    }

    /**
     * delete error
     * @param id
     * @returns {boolean}
     */

  }, {
    key: 'remove',
    value: function remove(id) {
      if (!id) return false;
      if (!this.has(id)) return false;
      delete this.errors[id];
      return true;
    }

    /**
     * get error
     * @param id
     * @returns {*}
     */

  }, {
    key: 'get',
    value: function get(id) {
      if (!id) return false;
      if (!this.has(id)) return false;
      return this.errors[id];
    }

    /**
     * render logs in console
     */

  }, {
    key: 'log',
    value: function log() {
      console.error('has following Errors:', this.errors);
    }

    /**
     * get all errors
     * @returns {{}|*}
     */

  }, {
    key: 'all',
    value: function all() {
      return this.errors;
    }
  }]);

  return SimpleErrorObject;
}();

exports.default = SimpleErrorObject;